<template lang="pug">
form.contact-form(method="post", name="contact", ref="form", @submit="submit")
    FormField(
        type="text",
        name="name",
        label="Your name",
        @input="(v) => (name = v)"
    )
    FormField(
        type="email",
        name="email",
        label="Your email",
        @input="(v) => (email = v)"
    )
    FormField(
        type="text",
        name="subject",
        label="Subject",
        @input="(v) => (subject = v)"
    )
    FormField(
        type="textarea",
        name="message",
        label="Message...",
        @input="(v) => (message = v)"
    )
    p.errorMessage(v-if="error != ''") {{ error }}
    .button-container
        button.primary-button.filled.smaller(
            type="submit",
            data-cursor-shrink,
            :class="{ disabled: isSent }",
            :disabled="isSent"
        ) {{ btntext }}
            span.lnr.lnr-sync.rotating(v-if="isLoading")
</template>

<script>
import FormField from "@/components/contact-form-field.vue";

export default {
    name: "contactform",
    components: {
        FormField,
    },
    data() {
        return {
            name: "",
            email: "",
            subject: "",
            message: "",
            error: "",
            btntext: "Let's work together!",
            isSent: false,
        };
    },

    methods: {
        async submit(e) {
            e.preventDefault();

            if (
                this.name == "" ||
                this.email == "" ||
                this.subject == "" ||
                this.message == ""
            ) {
                this.error =
                    "Please fill out all fields to ensure our team can contact you!";
                return false;
            }

            if (
                // eslint-disable-next-line no-useless-escape
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                    this.email
                ) == false
            ) {
                this.error =
                    "Please ensure the email address format is correct, i.e. <name>@<company>.xx";
                return false;
            }

            this.error = "";
            this.isLoading = true;
            this.btntext = "Sending message...";

            setTimeout(() => {
                this.isLoading = false;
                this.btntext = "Message sent!";
                this.isSent = true;
            }, 2000);
        },
    },
};
</script>

<style lang="scss">
.errorMessage {
    color: $cl-red;
    font-size: 1.4rem;
    margin-bottom: 1.2rem;
}

.button-container {
    text-align: right;

    .lnr-sync {
        display: inline-block;
    }
}
</style>